var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19961 3.19995C2.77526 3.19995 2.3683 3.36852 2.06824 3.66858C1.76818 3.96864 1.59961 4.3756 1.59961 4.79995V7.99995C1.59961 8.4243 1.76818 8.83126 2.06824 9.13132C2.3683 9.43138 2.77526 9.59995 3.19961 9.59995V4.79995H11.1996C11.1996 4.3756 11.031 3.96864 10.731 3.66858C10.4309 3.36852 10.024 3.19995 9.59961 3.19995H3.19961ZM4.79961 7.99995C4.79961 7.5756 4.96818 7.16864 5.26824 6.86858C5.5683 6.56852 5.97526 6.39995 6.39961 6.39995H12.7996C13.224 6.39995 13.6309 6.56852 13.931 6.86858C14.231 7.16864 14.3996 7.5756 14.3996 7.99995V11.2C14.3996 11.6243 14.231 12.0313 13.931 12.3313C13.6309 12.6314 13.224 12.8 12.7996 12.8H6.39961C5.97526 12.8 5.5683 12.6314 5.26824 12.3313C4.96818 12.0313 4.79961 11.6243 4.79961 11.2V7.99995ZM9.59961 11.2C10.024 11.2 10.4309 11.0314 10.731 10.7313C11.031 10.4313 11.1996 10.0243 11.1996 9.59995C11.1996 9.1756 11.031 8.76864 10.731 8.46858C10.4309 8.16852 10.024 7.99995 9.59961 7.99995C9.17526 7.99995 8.7683 8.16852 8.46824 8.46858C8.16818 8.76864 7.99961 9.1756 7.99961 9.59995C7.99961 10.0243 8.16818 10.4313 8.46824 10.7313C8.7683 11.0314 9.17526 11.2 9.59961 11.2Z",
    fill: "#507AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.f14102d8.svg";
export { ForwardRef as ReactComponent };